import TaskGroupView from './TaskGroupViewContainer';
export default TaskGroupView;
